module.exports = __webpack_public_path__ + "static/2-b29a4ac546c819170fb5de2c6f6eda77.svg";